// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import loadProduct from "@insite/client-framework/Store/Data/Products/Handlers/LoadProduct";

export default () => {
    const dispatch = useAppDispatch();
    return (id: string) => dispatch(loadProduct({ id }));
};
